import React, { Fragment } from 'react';
import classnames from 'classnames';
import * as PropTypes from 'prop-types';

import { isBrowser } from '../../utils';
import SmoothScrollAnchor from '../SmoothScrollAnchor';

import classes from './index.module.css';

const PieChartLegend = (props) => {
  const {
    chartData,
    samePageLinks,
    legendHeader,
    legendFooter,
    legendLinksAsButton,
  } = props;

  const getLegendItemView = (item) => {
    const { color, name, percent, link, indexed = true } = item;
    const backgroundColor = color || '#fff';

    return (
      <li
        className={classnames(
          classes.legendItem,
          'pie-chart-legend-item d-flex align-items-center my-0 py-0'
        )}
      >
        <div
          className={classnames(classes.legendCircle, 'pie-chart-legend-circle')}
          style={{ backgroundColor }}
        />
        <span
          className={classnames(classes.separator, 'pie-chart-legend-separator d-inline-block')}
        />
        {link && indexed ? (
          <>
            {samePageLinks ? (
              <SmoothScrollAnchor
                className={classnames(classes.link, 'list-link')}
                href={link}
                title={name}
              >
                {item.name}
              </SmoothScrollAnchor>
            ) : legendLinksAsButton ? (
              <span
                role="link"
                className={classnames(classes.link, 'list-link z-link font-weight-600')}
                onClick={() => isBrowser() && (window.location.href = link)}
              >
                {name}
              </span>
            ) : (
              <a className={classnames(classes.link, 'list-link')} href={link}>
                {name}
              </a>
            )}
            <span className="openSansBlackBold">{`, ${percent}%`}</span>
          </>
        ) : (
          <>
            <span>{name}</span>
            <span className="openSansBlackBold">{`, ${percent}%`}</span>
          </>
        )}
      </li>
    );
  };

  return (
    <ul className="pie-chart-legend-container z-m-0 z-p-0" style={{ paddingLeft: '0 !important' }}>
      {legendHeader && legendHeader}
      {chartData.map((item, index) => {
        return (
          <Fragment key={item.name + index}>
            <div className={classnames({ 'mt-2': index > 0 })}>
              {getLegendItemView(item)}
            </div>
          </Fragment>
        );
      })}
      {legendFooter && legendFooter}
    </ul>
  );
};

const propTypes = {
  chartData: PropTypes.arrayOf(PropTypes.any),
  samePageLinks: PropTypes.bool,
  legendHeader: PropTypes.any,
  legendFooter: PropTypes.any,
  legendLinksAsButton: PropTypes.bool,
};

const defaultProps = {
  chartData: [],
  samePageLinks: false,
  legendHeader: '',
  legendFooter: '',
  legendLinksAsButton: false,
};

PieChartLegend.propTypes = propTypes;
PieChartLegend.defaultProps = defaultProps;

export default PieChartLegend;
